// extracted by mini-css-extract-plugin
export var blink = "_61-2";
export var cursor = "_61-1";
export var reactMarkdown = "_61-3";
export var streamingText = "_61-0";